module.exports = __webpack_public_path__ + "img/Search.49c2f64b.svg";